import { render, staticRenderFns } from "./ESGcreate.vue?vue&type=template&id=24f26aea&scoped=true&lang=html"
import script from "./ESGcreate.vue?vue&type=script&lang=js"
export * from "./ESGcreate.vue?vue&type=script&lang=js"
import style0 from "./ESGcreate.vue?vue&type=style&index=0&id=24f26aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f26aea",
  null
  
)

export default component.exports